<template>
  <section class="dp-layout agreement-coin-records">
    <section class="dp-left">
      <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
    </section>
    <section class="dp-right">
      <div class="toolbar-filter-bar">
        <el-form :inline="true" class="toolbar-filter-form">
          <div class="toolbar-filter-fields">
            <el-form-item label="类型">
              <el-select v-model="filters.coinTypeId" clearable placeholder="全部" class="toolbar-field-w-md">
                <el-option v-for="t in typeOptions" :key="t.Id" :label="t.Name" :value="t.Id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="学生">
              <el-input v-model="filters.studentName" clearable placeholder="姓名，支持模糊" class="toolbar-field-w-md"></el-input>
            </el-form-item>
            <el-form-item label="时间范围">
              <el-date-picker
                v-model="filters.dateRange"
                type="daterange"
                start-placeholder="开始"
                end-placeholder="结束"
                value-format="yyyy-MM-dd"
                class="toolbar-field-w-daterange"
                clearable
              ></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="small" icon="el-icon-search" @click="query">查询</el-button>
            </el-form-item>
          </div>
          <div class="toolbar-filter-actions">
            <el-button size="small" type="info" icon="el-icon-refresh-left" @click="reset">重置</el-button>
            <el-button size="small" type="warning" icon="el-icon-download" :loading="exporting" @click="exportExcel">导出</el-button>
          </div>
        </el-form>
      </div>

      <div class="tbl-scroll-host">
      <el-table :data="list" v-loading="loading" border style="width: 100%;" height="100%">
        <el-table-column prop="CreateTime" label="时间" min-width="160" align="center">
          <template slot-scope="scope">{{ formatTime(scope.row.CreateTime) }}</template>
        </el-table-column>
        <el-table-column prop="StudentName" label="学生" min-width="100" align="center"></el-table-column>
        <el-table-column prop="DepartmentName" label="班级" min-width="120" align="center"></el-table-column>
        <el-table-column prop="CoinTypeName" label="类型" min-width="100" align="center"></el-table-column>
        <el-table-column prop="FaceValue" label="面值" width="80" align="center"></el-table-column>
        <el-table-column prop="Score" label="币分" width="80" align="center"></el-table-column>
        <el-table-column prop="EvaluationItemName" label="评价项" min-width="120" align="center"></el-table-column>
        <el-table-column prop="EvaluationScore" label="点评分" width="90" align="center"></el-table-column>
        <el-table-column prop="OperatorName" label="操作人" min-width="100" align="center"></el-table-column>
        <el-table-column label="来源" width="100" align="center">
          <template slot-scope="scope">{{ formatSource(scope.row.Source) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="90" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="revoke(scope.row)">撤销</el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <div class="pagination-container">
        <el-pagination
          layout="total, sizes, prev, pager, next"
          :total="pagination.total"
          :current-page.sync="pagination.page"
          :page-size.sync="pagination.pageSize"
          :page-sizes="[10, 20, 50, 100]"
          @current-change="loadData"
          @size-change="handleSizeChange"
        ></el-pagination>
      </div>
    </section>
  </section>
</template>

<script>
import DepartmentPane from '../../components/DepartmentPane';
import {
  getAgreementCoinRecords,
  getAgreementCoinTypes,
  revokeAgreementCoin,
  exportAgreementCoinRecords
} from '../../api/modules/agreement-coin';
import { resolveActiveSchoolId, treeNodeDeptId } from '../../utils/deptCascaderProps';

const SOURCE_LABEL = {
  Cplate: '班牌',
  TeacherApi: '教师补录',
  WebAdmin: 'Web后台'
};

export default {
  name: 'AgreementCoinRecords',
  components: { DepartmentPane },
  data() {
    return {
      loading: false,
      exporting: false,
      schoolDepartmentId: null,
      classId: null,
      typeOptions: [],
      filters: {
        coinTypeId: null,
        studentName: '',
        dateRange: []
      },
      list: [],
      pagination: { page: 1, pageSize: 10, total: 0 }
    };
  },
  methods: {
    /** 来源英文码转中文展示。创建于 2026-07-28 */
    formatSource(source) {
      if (!source) return '—';
      return SOURCE_LABEL[source] || source;
    },
    treeNodeClick(data) {
      const deptId = treeNodeDeptId(data);
      if (!deptId) return;
      const orgType = String((data && (data.DeptOrgType || data.deptOrgType)) || '').toLowerCase();
      const hasChildren = !!(data.children && data.children.length);
      const isLeaf = data.IsHasChildren === false || data.isLeaf === true || !hasChildren;
      if (orgType === 'school' || orgType === 'affiliateschool') {
        this.classId = null;
        this.schoolDepartmentId = deptId;
      } else if (isLeaf) {
        this.classId = deptId;
        this.schoolDepartmentId = resolveActiveSchoolId(this) || null;
      } else {
        this.classId = null;
        this.schoolDepartmentId = resolveActiveSchoolId(this) || deptId;
      }
      this.loadTypes();
      this.query();
    },
    loadTypes() {
      if (!this.schoolDepartmentId) return;
      getAgreementCoinTypes({
        schId: String(this.schoolDepartmentId),
        schoolDepartmentId: this.schoolDepartmentId
      }).then(res => {
        if (res.data && res.data.success) this.typeOptions = res.data.response || [];
      });
    },
    query() {
      this.pagination.page = 1;
      this.loadData();
    },
    reset() {
      this.filters = { coinTypeId: null, studentName: '', dateRange: [] };
      this.query();
    },
    handleSizeChange() {
      this.pagination.page = 1;
      this.loadData();
    },
    formatTime(v) {
      if (!v) return '';
      return String(v).replace('T', ' ').substring(0, 19);
    },
    /** 构建当前筛选参数（查询、导出共用） */
    buildFilterParams() {
      const params = {
        schId: this.schoolDepartmentId ? String(this.schoolDepartmentId) : undefined,
        schoolDepartmentId: this.schoolDepartmentId || undefined,
        classId: this.classId || undefined,
        coinTypeId: this.filters.coinTypeId || undefined,
        studentName: (this.filters.studentName && String(this.filters.studentName).trim()) || undefined
      };
      if (this.filters.dateRange && this.filters.dateRange.length === 2) {
        params.startTime = this.filters.dateRange[0];
        params.endTime = this.filters.dateRange[1];
      }
      return params;
    },
    loadData() {
      this.loading = true;
      const params = Object.assign({}, this.buildFilterParams(), {
        page: this.pagination.page,
        pageSize: this.pagination.pageSize
      });
      getAgreementCoinRecords(params).then(res => {
        this.loading = false;
        if (res.data && res.data.success) {
          const page = res.data.response || {};
          this.list = page.data || [];
          this.pagination.total = page.dataCount || 0;
        } else {
          this.$message.error((res.data && res.data.msg) || '查询失败');
        }
      }).catch(() => { this.loading = false; });
    },
    /** 按当前筛选条件调用后端接口导出 Excel。创建于 2026-07-25 */
    async exportExcel() {
      try {
        const response = await exportAgreementCoinRecords(this.buildFilterParams());
        const blob = response && response.data;
        if (!blob) {
          this.$message.error('导出数据为空');
          return;
        }
        if (blob.type && blob.type.indexOf('application/json') >= 0) {
          const text = await blob.text();
          let msg = '导出失败';
          try {
            const json = JSON.parse(text);
            msg = json.msg || json.message || msg;
          } catch (e) { /* ignore */ }
          this.$message.error(msg);
          return;
        }
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `协约币获得记录_${this.buildExportDateSuffix()}.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        let msg = '导出失败，请稍后重试';
        try {
          const errBlob = error && error.response && error.response.data;
          if (errBlob && typeof errBlob.text === 'function') {
            const text = await errBlob.text();
            if (text) {
              try {
                const json = JSON.parse(text);
                msg = json.msg || json.message || text;
              } catch (e) {
                msg = text;
              }
            }
          }
        } catch (e) { /* ignore */ }
        this.$message.error(msg);
      }
    },
    /** 导出文件名日期后缀 */
    buildExportDateSuffix() {
      if (this.filters.dateRange && this.filters.dateRange.length === 2) {
        return this.filters.dateRange.map(x => String(x).replace(/-/g, '')).join('_');
      }
      return '全部';
    },
    revoke(row) {
      this.$confirm(`确认撤销「${row.StudentName}」面值 ${row.FaceValue} 的协约币？`, '提示', { type: 'warning' })
        .then(() => revokeAgreementCoin({ RecordId: row.Id }))
        .then(res => {
          if (res.data && res.data.success) {
            this.$message.success('已撤销');
            this.loadData();
          } else {
            this.$message.error((res.data && res.data.msg) || '撤销失败');
          }
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
/* 左右栏宽度/卡片样式走全局 split-layout.css（.dp-left = 250px） */
.toolbar { margin-bottom: 8px; }
</style>
